export function isValidEmail(email: string): boolean {
  return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) !== null;
}
